import { useEffect } from 'react';
import { canUseDOM } from "../../utils/canUseDOM";

var getAllParents = function getAllParents(element) {
  var mutableParents = [];
  var currentNode = element;

  while (currentNode) {
    if (currentNode !== element) {
      mutableParents.push(currentNode);
    }

    currentNode = currentNode.parentElement;
  }

  return mutableParents;
};

export function useRecalculatePosition(_ref) {
  var anchorRef = _ref.anchorRef,
      onChangePosition = _ref.onChangePosition;
  useEffect(function () {
    if (!canUseDOM) {
      return undefined;
    }

    var allParents = anchorRef !== null && anchorRef !== void 0 && anchorRef.current ? getAllParents(anchorRef.current) : [];
    window.addEventListener('resize', onChangePosition);
    window.addEventListener('scroll', onChangePosition);
    allParents.forEach(function (parentEl) {
      parentEl.addEventListener('scroll', onChangePosition);
    });
    return function () {
      window.removeEventListener('resize', onChangePosition);
      window.removeEventListener('scroll', onChangePosition);
      allParents.forEach(function (parentEl) {
        parentEl.removeEventListener('scroll', onChangePosition);
      });
    };
  }, [anchorRef, onChangePosition]);
}